const { debounce } = require('lodash');
const { getStyle, stripeUnit } = require('./functions');

let MAX_LINES = 5;

function truncateContent() {
    const $wrapper = $('.js-read-more-wrapper');
    const $content = $('.js-read-more-content');
    const $btn = $('.js-read-more');
    const lineHeight = stripeUnit(getStyle($content[0], 'line-height'), 'px');

    $wrapper.addClass('limited');
    $content.removeClass('truncate');

    // If content is higher than MAX_LINES and user didn't click on 'Read More', then truncate it
    const isBigger = ($content.innerHeight() > lineHeight * MAX_LINES) && !$content.is('.long');
    $wrapper.removeClass('limited');
    $content.toggleClass('truncate', isBigger);
    $btn.toggleClass('d-none', !isBigger);
}

function readMoreClick(e) {
    const $this = $(e.currentTarget);
    const $content = $('.js-read-more-content');

    $this.hide();
    $content.toggleClass('truncate long');
}

module.exports = {
    init: (maxlines) => {
        MAX_LINES = maxlines || MAX_LINES;

        $(document).on('click', '.js-read-more', readMoreClick);
        $(window).on('load resize orientationchange', debounce(truncateContent, 100));
    },
};
